import { Box, Button, Checkbox, Flex, Grid, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck } from "@tabler/icons-react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";

interface CreateSerialStatusModel {
  id: number;
  code: string | null;
  name: string | null;
  status: boolean | string | null;
  createdDate: string | null;
  createdBy: number | null;
  lastUpdatedDate: string | null;
  lastUpdatedBy: number | null;
}

const CreateSerialStatus = ({ onSuccess }: { onSuccess: any }) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const form = useForm<CreateSerialStatusModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      code: null,
      name: null,
      status: true,
      createdDate: null,
      createdBy: null,
      lastUpdatedDate: null,
      lastUpdatedBy: null,
    },

    transformValues: (values) => ({
      ...values,
      status: values.status ? "Y" : "N",
    }),

    validate: {
      code: (value: string | null) => {
        if (!value || String(value).trim().length === 0) {
          return "Vui lòng nhập mã trạng thái serial !";
        }

        if (/\s/.test(String(value))) {
          return "Mã trạng thái serial không được chứa khoảng trắng !";
        }
      },
      name: (value: string | null) => {
        if (!value || String(value).length === 0) {
          return "Vui lòng nhập trạng thái serial !";
        }
      },
    },
  });

  const handleCreateSerialStatus = async (
    dataSubmit: CreateSerialStatusModel
  ) => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/TblSerialStatus/create",
        dataSubmit
      );

      if (res && res.success) {
        NotificationExtension.Success("Tạo mới trạng thái serial thành công !");
        setTimeout(() => {
          onSuccess();
          modals.closeAll();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box
      component="form"
      maw={400}
      w={"27.5vw"}
      onSubmit={form.onSubmit((e: CreateSerialStatusModel) => {
        handleCreateSerialStatus(e);
      })}
    >
      <Grid mt={5}>
        <Grid.Col span={12}>
          <TextInput
            key={form.key("code")}
            label="Mã trạng thái serial"
            placeholder="Nhập mã trạng thái serial"
            withAsterisk
            {...form.getInputProps("code")}
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <TextInput
            key={form.key("name")}
            label="Trạng thái serial"
            placeholder="Nhập trạng thái serial"
            withAsterisk
            {...form.getInputProps("name")}
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"space-between"} align={"center"} gap={"xs"}>
        <Checkbox
          key={form.key("status")}
          label="Sử dụng"
          {...form.getInputProps("status", { type: "checkbox" })}
        />
        <Button
          leftSection={<IconCheck size={16} />}
          type="submit"
          loading={visible}
          disabled={visible}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default CreateSerialStatus;
